module.exports = __webpack_public_path__ + "static/2_SUPERSINGLE-c9124a41a3d759cb3cd7f04ff33c2fb3.png";